import { Component, ViewChild, ElementRef, } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { TicketManagementModel, IssueType } from "@app/models/ticketManagement/TicketManagementModel";
import { TransactionHistoryService } from "@app/services/transactionHistory/transactionHistory.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CustomerService } from "@app/services/customer-registration/customer.service";
import { SearchMerchant } from "@app/models/merchant/SearchMerchant";
import { MerchantListingService } from "@app/services/merchant/merchant-listing/merchant-listing.service";

@Component({
    selector: 'raiseTicket',
    templateUrl: './raiseTicket.component.html',
})
export class RaiseTicketComponent {
    isDisabled:boolean=true;
    temp: boolean = true;
    ticketManagementModel = new TicketManagementModel();
    ticketManagementList = new Array<TicketManagementModel>();
    ticketManagementDetailList = new Array<TicketManagementModel>();
    IssueTypeList = new Array<IssueType>();
    statusMobileNo: boolean = false;
    errorMessageMobileNo: string;
    fidx = 1;
    fileExt: string;
    UploadedImageName: any;
    invalidFileTypeErrorMessage: string = '';
    searchMerchantListModel = null;
    searchMerchantModel = new SearchMerchant();
    EntityTypeId: string = "0";

    ticketId: number;
    constructor(private router: Router,
        private CustomerService: CustomerService,
        private transactionhistoryService: TransactionHistoryService,
        private toastr: ToastrService
        , private route: ActivatedRoute,
        private merchantListingService: MerchantListingService,
        private el: ElementRef) { }

    ngOnInit() {
        this.EntityTypeId = localStorage.getItem('EntityType');
        this.ticketManagementModel.TerminalId = 0;
        this.ticketManagementModel.IssueType = 0;
        this.ticketManagementModel.OutletId = 0;
        this.ticketManagementModel.MerchantCode = 0;
        this.route.params.subscribe(params => {
            if (params['MerchantId']) {
                this.ticketManagementModel.MerchantCode = params['MerchantId'];
            }
            if (params['OutletId']) {
                this.ticketManagementModel.OutletId = params['OutletId'];
                this.onSelectMerchant(this.ticketManagementModel.MerchantCode);
            }
            if (params['CityId']) {
                this.ticketManagementModel.CityId = params['CityId'];
            }
            if (params['StateId']) {
                this.ticketManagementModel.StateId = params['StateId'];
            }
            if (params['TerminalId']) {
                this.ticketManagementModel.TerminalId = params['TerminalId'];
                this.onSelectOutlet(this.ticketManagementModel.OutletId);
            }
        });
        if (this.EntityTypeId == '115')
            this.getMerchantListingDetails();
        else
            this.onSelectMerchant(0);
        this.GetIssueTypeList();
    }
    getMerchantListingDetails() {
        this.searchMerchantListModel = new Array<SearchMerchant>();
        this.merchantListingService.getMerchantListingDetails(this.searchMerchantModel).subscribe(data => {
            this.searchMerchantListModel = JSON.parse(JSON.stringify(data));
            console.log(this.searchMerchantListModel);
        });
    }
    getMerchantOutlet() {

    }
    // GetTerminalListOnMerchantId() {
    //     this.transactionhistoryService.GetTerminalListOnMerchantId().subscribe(data => {
    //         this.ticketManagementList = JSON.parse(JSON.stringify(data));
    //         //this.onSelectOutlet(this.ticketManagementModel.OutletId);
    //         console.log(this.ticketManagementList);

    //     });
    // }

    GetIssueTypeList() {
        this.transactionhistoryService.getIssuerType().subscribe(data => {
            this.IssueTypeList = JSON.parse(JSON.stringify(data));
        });
    }
    onSelectTerminal(event) {
        this.ticketManagementModel.TerminalId = event;
    }

    onSelectOutlet(outledId) {
        for (let data of this.ticketManagementList) {
            if (data.OutletId == outledId) {
                this.ticketManagementModel.CityId = data.CityId;
                this.ticketManagementModel.StateId = data.StateId;
            }
        }
        //this.ticketManagementModel.OutletId = event;
        this.transactionhistoryService.getTerminalByOutletCode(outledId).subscribe(data => {
            this.ticketManagementDetailList = JSON.parse(JSON.stringify(data));
        });
    }
    onSelectMerchant(merchantId) {
        // debugger
        for (let data of this.ticketManagementList) {
            if (data.MerchantId == merchantId) {
                this.ticketManagementModel.OutletId=data.OutletId;
            }
        }
        this.transactionhistoryService.GetTerminalListOnMerchantId(merchantId).subscribe(data => {
            this.ticketManagementList = JSON.parse(JSON.stringify(data));
        });
    }

    SaveRaisedTicketData(forms: NgForm) {
        // debugger
        this.transactionhistoryService.SaveRaisedTicketData(this.ticketManagementModel).subscribe(data => {
            this.ticketId = JSON.parse(JSON.stringify(data));
            if (this.ticketId > 0) {
                this.isDisabled=false;
                //forms.reset();
                //this.ticketManagementModel.FileName = "";
                this.toastr.success("Saved Successfully with ticket id:IGLSCP" + this.ticketId + '_' + new Date(Date.now()).toLocaleDateString('en-GB'));
                // this.ticketManagementModel.TerminalId = 0;
                // this.ticketManagementModel.IssueType = 0;
                // this.ticketManagementModel.OutletId = 0;
                this.ticketManagementDetailList.forEach(data => {

                    if(data.TerminalId==this.ticketManagementModel.TerminalId){
                        this.ticketManagementModel.TerminalNumber=data.TerminalNumber;
                    }
                });
                this.router.navigate(['/secure/admin/HelpDesk/'+ this.ticketManagementModel.MerchantCode + '/' + this.ticketManagementModel.OutletId + '/' + this.ticketManagementModel.TerminalNumber]);
            }
            else if (this.ticketId <= 0) {
                this.toastr.error("Error saving details.Try again!!");
            }
        });
    }

    isNumberValidationMobileNo(event: any) {
        const pattern = /[0-9\ ]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar) && event.keyCode != 8) {
            this.statusMobileNo = true;
            this.errorMessageMobileNo = "Enter only numbers";
            event.preventDefault();
        }

        else {
            this.statusMobileNo = false;
            this.errorMessageMobileNo = " ";
        }
    }

    upload($event, uploaderIndex: number, value: number) {
        let imageName = '#photo' + uploaderIndex;
        let inputEl: HTMLInputElement = this.el.nativeElement.querySelector(imageName);
        let fileCount: number = inputEl.files.length;
        let formData = new FormData();

        if (this.validateFileType(inputEl.files.item(0).name)) {
            if (fileCount > 0) {
                formData.append('photo', inputEl.files.item(0));
                formData.append('Check', inputEl.files.item(1));
                this.transactionhistoryService.fileUpload(formData, this.ticketManagementModel.OutletId).subscribe(data => {
                    this.ticketManagementModel.FileName = data[0].fileName;
                    this.el.nativeElement.querySelector(imageName).value = "";
                },
                    error => {
                        this.el.nativeElement.querySelector(imageName).value = "";
                    }
                );
            }
        }
    }

    validateFileType(fileName: string) {
        var validExts = new Array(".bmp", ".xls", ".pdf", ".png", ".jpg", ".svg", ".doc");
        this.fileExt = fileName.substring(fileName.lastIndexOf('.'));
        if (validExts.indexOf(this.fileExt) < 0) {
            this.invalidFileTypeErrorMessage = 'Invalid file type';
            this.UploadedImageName = "";
            return false;
        }
        else {
            this.invalidFileTypeErrorMessage = '';
            return true;
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/components/common/help-desk/raiseTicket.component.ts